import { configureStore } from '@reduxjs/toolkit';
import { authReducer } from './slices/authSlice';
import { itemsReducer } from './slices/itemSlice';
import { deliveryReceiptReducer } from './slices/deliveryReceiptSlice';
import { deliveryReceiptDocumentReducer } from '@data/slices/deliveryReceiptDocumentSlice.ts';

export const rootReducer = {
  auth: authReducer,
  items: itemsReducer,
  deliveryReceipt: deliveryReceiptReducer,
  deliveryReceiptDocument: deliveryReceiptDocumentReducer,
};

export const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['image/addPendingImageUpload'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
